import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  customerCode: {
    type: "text",
    name: "customerCode",
    label: "Customer Code",
    errorMsg: "Customer Code is required.",
    maxLength: 20,
    tabIndex: 1,
    required: true,
    disabled: true,
  },
  warehouseCode: {
    type: "select",
    name: "warehouseCode",
    label: "Warehouse Code",
    required: true,
    errorMsg: "Warehouse Code is required.",
  },
  orderNumber: {
    type: "text",
    name: "orderNumber",
    label: "Order Number",
    maxLength: 20,
    disabled: true,
  },
  status: {
    type: "text",
    name: "status",
    label: "Status",
    disabled: true,
  },
  customerOrderNumber: {
    type: "text",
    name: "customerOrderNumber",
    label: "Customer Order Number",
    required: true,
    errorMsg: "Customer Order Number is required",
    maxLength: 20,
    editable: false,
  },
  orderType: {
    type: "select",
    name: "orderType",
    label: "Order Type",
    required: true,
    errorMsg: "Order Type is required",
  },
  orderDate: {
    type: "date",
    name: "orderDate",
    label: "Order Date",
    required: true,
    errorMsg: "Order Date is required",
  },
  shipDate: {
    type: "date",
    name: "shipDate",
    label: "Ship Date",
  },
  // shipping
  consigneeCode: {
    type: "select",
    name: "consigneeCode",
    label: "Consignee Code",
  },
  shipCompany: {
    type: "text",
    name: "shipCompany",
    label: "Company",
    maxLength: 100,
  },
  customerName: {
    type: "text",
    name: "customerName",
    label: "Customer Name",
    maxLength: 100,
    required: true,
    errorMsg: "Customer Name is required",
  },
  shipContactPerson: {
    type: "text",
    name: "shipContactPerson",
    label: "Contact Person",
    maxLength: 100,
  },
  shipAddress1: {
    type: "text",
    name: "shipAddress1",
    label: "Address 1",
    maxLength: 200,
    required: true,
    errorMsg: "Ship Address 1 is required",
  },
  shipAddress2: {
    type: "text",
    name: "shipAddress2",
    label: "Address 2",
    maxLength: 200,
  },
  shipPostcode: {
    type: "text",
    name: "shipPostcode",
    label: "Postcode",
    maxLength: 10,
    required: true,
    errorMsg: "Ship Postcode is required",
  },
  shipCity: {
    type: "text",
    name: "shipCity",
    label: "City",
    maxLength: 100,
    required: true,
    errorMsg: "Ship City is required",
  },
  shipState: {
    type: "text",
    name: "shipState",
    label: "State",
    maxLength: 100,
    required: true,
    errorMsg: "Ship State is required",
  },
  shipCountry: {
    type: "select",
    name: "shipCountry",
    label: "Country",
    maxLength: 100,
    required: true,
    errorMsg: "Ship Country is required",
  },
  shipTelNo: {
    type: "text",
    name: "shipTelNo",
    label: "Tel No",
    maxLength: 20,
    required: true,
    errorMsg: "Ship Tel No is required",
  },
  shipEmail: {
    type: "text",
    name: "shipEmail",
    label: "Email",
    maxLength: 100,
  },
  // billing
  billCompany: {
    type: "text",
    name: "billCompany",
    label: "Company",
    maxLength: 100,
  },
  billContactPerson: {
    type: "text",
    name: "billContactPerson",
    label: "Contact Person",
    maxLength: 100,
  },
  billAddress1: {
    type: "text",
    name: "billAddress1",
    label: "Address 1",
    maxLength: 200,
  },
  billAddress2: {
    type: "text",
    name: "billAddress2",
    label: "Address 2",
    maxLength: 200,
  },
  billPostcode: {
    type: "text",
    name: "billPostcode",
    label: "Postcode",
    maxLength: 10,
  },
  billCity: {
    type: "text",
    name: "billCity",
    label: "City",
    maxLength: 100,
  },
  billState: {
    type: "text",
    name: "billState",
    label: "State",
    maxLength: 100,
  },
  billCountry: {
    type: "select",
    name: "billCountry",
    label: "Country",
    maxLength: 100,
  },
  billTelNo: {
    type: "text",
    name: "billTelNo",
    label: "Tel No",
    maxLength: 20,
  },
  billEmail: {
    type: "text",
    name: "billEmail",
    label: "Email",
    maxLength: 100,
  },
  // carrier
  carrier: {
    type: "select",
    name: "carrier",
    label: "Carrier",
    maxLength: 20,
  },
  shipmentType: {
    type: "select",
    name: "shipmentType",
    label: "Shipment Type",
  },
  shippingZone: {
    type: "text",
    name: "shippingZone",
    label: "Shipping Zone (required for Malaysia)",
    maxLength: 20,
    required: true,
    errorMsg: "Shipping Zone is required",
  },
  collectionPoint: {
    type: "text",
    name: "collectionPoint",
    label: "Collection Point",
    maxLength: 100,
  },

  referenceNo: {
    type: "text",
    name: "referenceNo",
    label: "Reference No",
    maxLength: 20,
  },
  poNo: {
    type: "text",
    name: "poNo",
    label: "PO No",
    maxLength: 20,
  },
  salesRepName: {
    type: "text",
    name: "salesRepName",
    label: "Sales Rep Name",
    maxLength: 50,
  },
  paymentTerm: {
    type: "text",
    name: "paymentTerm",
    label: "Payment Term",
    maxLength: 20,
  },
  handlingInstruction: {
    type: "text",
    name: "handlingInstruction",
    label: "Handling Instruction",
    maxLength: 300,
  },
  remark: {
    type: "text",
    name: "remark",
    label: "Remark",
    maxLength: 300,
  },
  applyBilling: {
    type: "button",
    name: "applyBilling",
    label: "Apply Billing",
  },
};

const {
  customerCode,
  warehouseCode,
  orderNumber,
  status,
  customerOrderNumber,
  orderType,
  orderDate,
  shipDate,
  consigneeCode,
  shipCompany,
  customerName,
  shipContactPerson,
  shipAddress1,
  shipAddress2,
  shipPostcode,
  shipCity,
  shipState,
  shipCountry,
  shipTelNo,
  shipEmail,
  billCompany,
  billContactPerson,
  billAddress1,
  billAddress2,
  billPostcode,
  billCity,
  billState,
  billCountry,
  billTelNo,
  billEmail,
  carrier,
  shipmentType,
  shippingZone,
  collectionPoint,
  referenceNo,
  poNo,
  salesRepName,
  paymentTerm,
  handlingInstruction,
  remark,
  applyBilling,
} = formField;

export const headerRender = [
  [orderNumber, customerCode, warehouseCode, status],
  [customerOrderNumber, orderDate, shipDate, orderType],
  [
    {
      type: "fieldset",
      label: "Shipping",
      fieldsetRender: [
        [consigneeCode, shipCompany, customerName, shipContactPerson],
        [shipAddress1, shipAddress2, shipPostcode, shipCity],
        [shipState, shipCountry, shipTelNo, shipEmail],
        [applyBilling],
      ],
    },
  ],
  [
    {
      type: "fieldset",
      label: "Billing",
      fieldsetRender: [
        [billCompany, billContactPerson],
        [billAddress1, billAddress2, billPostcode, billCity],
        [billState, billCountry, billTelNo, billEmail],
      ],
    },
  ],
  [
    {
      type: "fieldset",
      label: "Carrier",
      fieldsetRender: [[shippingZone, shipmentType, carrier, collectionPoint]],
    },
  ],
  [referenceNo, poNo, salesRepName, paymentTerm],
  [handlingInstruction, remark],
];

export const headerValues = getInitialValues(formField);

export const headerValidation = Yup.object().shape({
  [customerCode.name]: Yup.string().nullable().required(customerCode.errorMsg),
  [warehouseCode.name]: Yup.string().nullable().required(warehouseCode.errorMsg),
  [status.name]: Yup.string().nullable(),
  [customerOrderNumber.name]: Yup.string()
    .nullable()
    .max(customerOrderNumber.maxLength)
    .required(customerOrderNumber.errorMsg),
  [orderType.name]: Yup.string().nullable().required(orderType.errorMsg),
  [orderDate.name]: Yup.string().nullable().required(orderDate.errorMsg),
  [shipDate.name]: Yup.string().nullable(),
  // shipping
  [consigneeCode.name]: Yup.string().nullable(),
  [shipCompany.name]: Yup.string().nullable().max(shipCompany.maxLength),
  [customerName.name]: Yup.string()
    .nullable()
    .max(customerName.maxLength)
    .required(customerName.errorMsg)
    .when("shipmentType", {
      is: "SelfCollect",
      then: (schema) => schema.notRequired(),
    }),
  [shipContactPerson.name]: Yup.string().nullable().max(shipContactPerson.maxLength),
  [shipAddress1.name]: Yup.string()
    .nullable()
    .max(shipAddress1.maxLength)
    .required(shipAddress1.errorMsg)
    .when("shipmentType", {
      is: "SelfCollect",
      then: (schema) => schema.notRequired(),
    }),
  [shipAddress2.name]: Yup.string().nullable().max(shipAddress2.maxLength),
  [shipPostcode.name]: Yup.string()
    .nullable()
    .max(shipPostcode.maxLength)
    .required(shipPostcode.errorMsg)
    .when("shipmentType", {
      is: "SelfCollect",
      then: (schema) => schema.notRequired(),
    }),
  [shipCity.name]: Yup.string()
    .nullable()
    .max(shipCity.maxLength)
    .required(shipCity.errorMsg)
    .when("shipmentType", {
      is: "SelfCollect",
      then: (schema) => schema.notRequired(),
    }),
  [shipState.name]: Yup.string()
    .nullable()
    .max(shipState.maxLength)
    .required(shipState.errorMsg)
    .when("shipmentType", {
      is: "SelfCollect",
      then: (schema) => schema.notRequired(),
    }),
  [shipCountry.name]: Yup.string()
    .nullable()
    .max(shipCountry.maxLength)
    .required(shipCountry.errorMsg)
    .when("shipmentType", {
      is: "SelfCollect",
      then: (schema) => schema.notRequired(),
    }),
  [shipTelNo.name]: Yup.string()
    .nullable()
    .max(shipTelNo.maxLength)
    .required(shipTelNo.errorMsg)
    .when("shipmentType", {
      is: "SelfCollect",
      then: (schema) => schema.notRequired(),
    }),
  [shipEmail.name]: Yup.string().nullable().max(shipEmail.maxLength),
  // billing
  [billCompany.name]: Yup.string().nullable().max(billCompany.maxLength),
  [billContactPerson.name]: Yup.string().nullable().max(billContactPerson.maxLength),
  [billAddress1.name]: Yup.string().nullable().max(billAddress1.maxLength),
  [billAddress2.name]: Yup.string().nullable().max(billAddress2.maxLength),
  [billPostcode.name]: Yup.string().nullable().max(billPostcode.maxLength),
  [billCity.name]: Yup.string().nullable().max(billCity.maxLength),
  [billState.name]: Yup.string().nullable().max(billState.maxLength),
  [billCountry.name]: Yup.string().nullable().max(billCountry.maxLength),
  [billTelNo.name]: Yup.string().nullable().max(billTelNo.maxLength),
  [billEmail.name]: Yup.string().nullable().max(billEmail.maxLength),
  // carrier
  [carrier.name]: Yup.string().nullable().max(carrier.maxLength),
  [shipmentType.name]: Yup.string().nullable(),
  [shippingZone.name]: Yup.string().nullable().max(shippingZone.maxLength),
  [collectionPoint.name]: Yup.string().nullable().max(collectionPoint.maxLength),
  //
  [referenceNo.name]: Yup.string().nullable().max(referenceNo.maxLength),
  [poNo.name]: Yup.string().nullable().max(poNo.maxLength),
  [salesRepName.name]: Yup.string().nullable().max(salesRepName.maxLength),
  [paymentTerm.name]: Yup.string().nullable().max(paymentTerm.maxLength),
  [handlingInstruction.name]: Yup.string().nullable().max(handlingInstruction.maxLength),
  [remark.name]: Yup.string().nullable().max(remark.maxLength),
});
